import React, { Component } from 'react';
import { withAsyncHandlers } from 'react-async-client';
import { withFormik, Form } from 'formik';
import { pathOr } from 'ramda';

import ServerError from 'components/common/fields/ServerError';

export default (formikOptions = {}) => WrappedComponent => {
    class FormWrapper extends Component {
        componentWillMount() {
            if (formikOptions.validationSchema) {
                if (!this.props.isValid) {
                    this.props.validateForm();
                }
                this.props.setStatus({
                    validationSchema: formikOptions.validationSchema.fields
                });
            }
        }

        handleSubmit = e => {
            const { status = {} } = this.props;

            this.props.setStatus({
                ...status,
                isSubmitStarted: true
            });

            this.props.handleSubmit(e);
        }

        render() {
            const { error } = pathOr(false, ['formAction', 'meta'], this.props);

            return (
                <Form onSubmit={this.handleSubmit} noValidate>
                    <WrappedComponent {...this.props} handleSubmit={this.handleSubmit} />
                    <ServerError error={error} />
                </Form>
            );
        }
    }

    const AsyncHandlers = withAsyncHandlers({
        formAction: {
            successHandler: props => {
                props.setSubmitting(false);
                props.onSuccess && props.onSuccess(props);
            },
            errorHandler: props => {
                props.setSubmitting(false);
                props.onError && props.onError(props);
            },
        }
    })(FormWrapper);


    return withFormik({
        handleSubmit: (formValues, { props: { formAction } }) => {
            const dispatch = formAction.dispatch || formAction;
            dispatch(formValues);
        },
        mapPropsToValues: ({ initialValues }) => initialValues,
        ...formikOptions
    })(AsyncHandlers);
};



// WEBPACK FOOTER //
// ./src/components/hocs/withForm.js